import { Charts } from './Charts';
import RegistersChartsDataProvider from './contexts/RegistersChartsDataContext';

const RegistersWrapper = () => {
    return (
        <RegistersChartsDataProvider>
            <Charts />
        </RegistersChartsDataProvider>
    );
};

export default RegistersWrapper;
